import React, { useState } from "react";
import { Form, Card, Button } from "react-bootstrap";
import validator from "validator";
import Bar from '../Bar';

// creating functional component ans getting props from app.js and destucturing them
const StepOne = ({ nextStep, handleFormData, values }) => {
  //creating error state for validation
  const [error, setError] = useState(false);

  // after form submit validating the form data using validator
  const submitFormData = (e) => {
    e.preventDefault();

    // checking if value of first name and last name is empty show error else take to step 2
    if (
      validator.isEmpty(values.fullName) ||
      validator.isEmpty(values.phoneNumber)
    ) {
      setError(true);
    } else {
      nextStep();
    }
  };

  return (
    <div>
      <Bar/>
      <Card style={{ marginTop: 100 }}>
        <Card.Body>
          <Form onSubmit={submitFormData}>
            <Form.Group className="mb-3">
              <Form.Label>Full Name<optional>*</optional></Form.Label>
              <Form.Control
                style={{ border: error ? "2px solid red" : "" }}
                name="fulltName"
                defaultValue={values.fullName}
                type="text"
                placeholder="Full Name"
                onChange={handleFormData("fullName")}
              />
              {error ? (
                <Form.Text style={{ color: "red" }}>
                  This is a required field
                </Form.Text>
              ) : (
                ""
              )}
            </Form.Group>
            <Form.Group className="mb-3">
              <Form.Label>Company Name <optional>(optional)</optional> </Form.Label>
              <Form.Control
                name="companyName"
                defaultValue={values.companyName}
                type="text"
                placeholder="Company Name"
                onChange={handleFormData("companyName")}
              />
            </Form.Group>
            <Form.Group className="mb-3">
              <Form.Label>E-mail<optional>*</optional></Form.Label>
              <Form.Control
                style={{ border: error ? "2px solid red" : "" }}
                type="email"
                placeholder="Business Email"
                defaultValue={values.email}
                onChange={handleFormData("email")}
              />
              {error ? (
                <Form.Text style={{ color: "red" }}>
                  This is a required field
                </Form.Text>
              ) : (
                ""
              )}
            </Form.Group>
            <Form.Group className="mb-3">
              <Form.Label>Phone Number<optional>*</optional></Form.Label>
              <Form.Group id="basic-addon1">+963</Form.Group>
              <Form.Control
                style={{ border: error ? "2px solid red" : "" }}
                name="phoneNumber"
                defaultValue={values.phoneNumber}
                type="number"
                placeholder="Business Phone Number"
                onChange={handleFormData("phoneNumber")}
              />
              {error ? (
                <Form.Text style={{ color: "red" }}>
                  This is a required field
                </Form.Text>
              ) : (
                ""
              )}
            </Form.Group>
            <Button variant="primary" type="submit">
              Continue
            </Button>
          </Form>
        </Card.Body>
      </Card>
    </div>
  );
};

export default StepOne;